import { flowRight } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import withAuth from '../../hoc/with-auth';
import withEnvironment from '../../hoc/with-environment';

const CurrentUserProfileLink = ({ children, currentUser, navigation: { ProfileLink } }) =>
  <ProfileLink user={currentUser}>
    {children}
  </ProfileLink>;

CurrentUserProfileLink.propTypes = {
  children: PropTypes.node,
  currentUser: PropTypes.object,
  navigation: PropTypes.object,
};

export default flowRight(
  withAuth,
  withEnvironment({ navigation: 'navigation' }),
)(CurrentUserProfileLink);



// WEBPACK FOOTER //
// ./app/containers/current-user-profile-link/current-user-profile-link.js